import { useBucket } from '@mc/experiments-react'

// Growthbook feature flag: https://app.growthbook.io/features/jar-4217-orchestrator-model
export const ORCHESTRATOR_MODEL_FLAG = 'jar-4217-orchestrator-model'

export const ORCHESTRATOR_MODEL_BUCKETS = [
  'control',
  'variant_1',
  'variant_2',
] as const

export type OrchestratorModelBucket =
  (typeof ORCHESTRATOR_MODEL_BUCKETS)[number]

// Model AB test: swaps only the cortex orchestrator LLM. The bucket key
// rides on every chat turn as `modelVariant`; cortex maps it to a concrete
// model (cortex/src/jarvis/agents/models.ts) and stamps it on latency
// metrics and turn logs as `variant`. Returns undefined when the user isn't
// enrolled — the field is then omitted and cortex uses the default model.
export const useOrchestratorModelVariantBucket = ():
  | OrchestratorModelBucket
  | undefined =>
  useBucket<OrchestratorModelBucket>(ORCHESTRATOR_MODEL_FLAG) || undefined
